/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiLastRefresh } from '../../models/api-last-refresh';

export interface ApiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet(http: HttpClient, rootUrl: string, params: ApiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiLastRefresh>> {
  const rb = new RequestBuilder(rootUrl, apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiLastRefresh>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet.PATH = '/api/SystemHistory/datasourceupdatestatus/{systemSerialNumber}/{systemMaterialNumber}';
apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiSystemHistoryDatasourceupdatestatusSystemSerialNumberSystemMaterialNumberGet.ROOTURL = '/tube';
